const FOOTER_LINKS = {
  '热门分类': ['动作电影', '喜剧电影', '爱情电影', '科幻电影', '恐怖惊悚', '动画电影', '纪录片', '战争电影'],
  '快速入口': ['影视榜单', '热门专题', '最新更新', '平台特色', '常见问题'],
  '关于我们': ['平台介绍', '联系我们', '移动端入口', '观众热评', '话题标签'],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="font-heading text-xl font-bold text-accent-400">
              6080电影网
            </span>
            <p className="mt-3 text-sm leading-relaxed text-foreground-300">
              高清电影免费在线观看平台，汇聚海量免费高清影视资源。
              极速秒开不缓冲，无广告纯净观影，每日更新最新电影，
              让您随时随地畅享影院级观影体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-600 hover:text-white transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-600 hover:text-white transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-600 hover:text-white transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link, idx) => (
                  <li key={idx}>
                    <a
                      href="#hero"
                      onClick={(e) => { e.preventDefault(); }}
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800">
          <h4 className="font-heading text-sm font-semibold text-white mb-3">合作伙伴</h4>
          <p className="text-xs text-foreground-500">诚邀优质影视内容平台与品牌方合作，共创高清观影新生态。</p>
        </div>

        <div className="mt-8 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 6080电影网 · 高清电影免费在线观看 · 本站所有内容仅供学习和交流
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#hero" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#hero" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}